import { formatNumber } from '@/utils/formatNumber';

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export default class DateIdentifier {
  year: number;
  month: number;
  date: number;
  hour: number;
  minute: number;

  constructor(dateCode: string) {
    // 20000101
    if (dateCode.length === 8) {
      // Standard 8 character code
      this.year = parseInt(dateCode.substring(0, 4), 10);
      this.month = parseInt(dateCode.substring(4, 6), 10);
      this.date = parseInt(dateCode.substring(6, 8), 10);
      this.hour = 0;
      this.minute = 0;
      return;
    }

    if (dateCode.length === 16) {
      // 16 character code
      const dateParts = dateCode.split(':');

      this.year = parseInt(dateParts[0], 10);
      this.month = parseInt(dateParts[1], 10);
      this.date = parseInt(dateParts[2], 10);
      this.hour = parseInt(dateParts[3], 10);
      this.minute = parseInt(dateParts[4], 10);
      return;
    }

    if (dateCode.length === 12) {
      // 12 character code
      this.year = parseInt(dateCode.substring(0, 4), 10);
      this.month = parseInt(dateCode.substring(4, 6), 10);
      this.date = parseInt(dateCode.substring(6, 8), 10);
      this.hour = parseInt(dateCode.substring(8, 10), 10);
      this.minute = parseInt(dateCode.substring(10, 12), 10);
      return;
    }

    throw new Error(`Unable to create DateIdentifier - invalid dateCode: ${dateCode}.`);
  }

  public getMonthName(monthNumber: number, shouldAbbreviate: boolean) {
    const fullMonthName = MONTH_NAMES[monthNumber - 1];

    if (shouldAbbreviate) {
      return fullMonthName.substring(0, 3);
    }

    return fullMonthName;
  }

  public getAbbreviatedDateString() {
    // 31 Jan
    const abbreviatedMonthName = this.getMonthName(this.month, true);

    return `${this.date} ${abbreviatedMonthName}`;
  }

  public getFullIntradayDateString() {
    // 31 Jan 2008 - 12:15
    const day = formatNumber(this.date, { desiredNumberOfLeadingZeros: 2 });
    const abbreviatedMonthName = this.getMonthName(this.month, true);
    const hour = formatNumber(this.hour, { desiredNumberOfLeadingZeros: 2 });
    const minute = formatNumber(this.minute, { desiredNumberOfLeadingZeros: 2 });

    return `${day} ${abbreviatedMonthName} ${this.year} - ${hour}:${minute}`;
  }
}
